import React from 'react';
import H from "@here/maps-api-for-javascript";

import { GetData } from "../../Api";
import FilterContext from '../../Hooks/Context';
import { withTranslation } from 'react-i18next';

class Map extends React.Component {

  static contextType = FilterContext;

  mapRef = React.createRef();

  constructor(props) {

    super(props);
    this.state = { 
      mapData: null,
      mapMarkerConfig : {
        'redMarkerImagePath' : '/images/pin_red.svg',
        'greenMarkerImagePath' : '/images/pin_green.svg',
        'yellowMarkerImagePath' : '/images/pin_yellow.svg',
      },
      factoryOverviewData: null,
      mapHeight: 0
    };

  }

  state = {
    map: null
  };

  setStyle(map){

    var provider = map.getBaseLayer().getProvider();
    var style = new H.map.Style('/maps/cloudvidia.yaml',
      'https://js.api.here.com/v3/3.1/styles/omv/');
    provider.setStyle(style);

  }

  addMarkerToGroup(group, coordinate, icon, html) {

    var marker = new H.map.Marker(coordinate,{ icon: icon });
    // add custom data to the marker
    marker.setData(html);
    group.addObject(marker);

  }

  GenerateHtmlInfoWindow = (mapPointSource, markerStatusColor, index) => {

    const { t } = this.props;
    let maphtmlData = `<div id='infowindow${index}'><div class='marker-heading' style='background-color: ${markerStatusColor}'>${mapPointSource.name}</div>`;
    mapPointSource.statistics && mapPointSource.statistics.forEach((mapData, index) => {
      maphtmlData += `<div style='padding: 10px 10px 0 10px;'>
        <div class='marker-process-heading' style='color:${ mapData.name === 'Quality' ? markerStatusColor : '#000000'}'>${mapData.value === null ? 'N/A' : `${mapData.value.toFixed(1)}%`}</div>
        <div class='marker-process-title'>${ t(mapData.name) }</div>
      </div>`;
    });
    maphtmlData += `<div class='close-marker-icon' data-ref=${ mapPointSource.factoryId }  style='background-color: ${markerStatusColor}'>+</div><div>`;
    return maphtmlData;
  }

  addInfoBubble(map, ui) {
    var group = new H.map.Group();
  
    map.addObject(group);
  
    // add 'tap' event listener, that opens info bubble, to the group
    group.addEventListener('tap', function (evt) {
      // event target is the marker itself, group is a parent event target
      // for all objects that it contains
      var bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
        // read custom data
        content: evt.target.getData()
      });

      // show info bubble
      ui.addBubble(bubble);
    }, false);

    this.state.mapData && this.state.mapData.forEach((mapPointSource, index) => {

        let OEEValue = mapPointSource.statistics.filter((oeevalue) => {
            return oeevalue.name === 'Quality';
        });

        let oeeValue = parseInt(OEEValue[0].value);
        let markerImage, markerStatus;
        if( oeeValue >= 90 ) {
          // Green
          markerImage  =  this.state.mapMarkerConfig.greenMarkerImagePath;
          markerStatus = '#3cc480';
        } else if( oeeValue > 60 && oeeValue < 90 ) {
          // Yellow
          markerImage  =  this.state.mapMarkerConfig.yellowMarkerImagePath;
          markerStatus = '#ffc60a';
        } else if( oeeValue <= 60 ) {
          // Red
          markerImage  =  this.state.mapMarkerConfig.redMarkerImagePath;
          markerStatus = '#ff5544';
        }
        
        let pngIcon = new H.map.Icon(markerImage, {size: {w: 25, h: 35}});
        let mapHtmlData = this.GenerateHtmlInfoWindow(mapPointSource, markerStatus, index);
      
        this.addMarkerToGroup(group, {lat: mapPointSource.location.lat, lng: mapPointSource.location.lng}, pngIcon, mapHtmlData);

    });
 
  }

  isEmptyObject(obj){
    return JSON.stringify(obj) === '{}';
  }

  Epoch(date) {
    return Math.round(new Date(date).getTime() / 1000.0);
  }

  GetFactoryOverview() {

    let queryParam = this.props.filterQuery.filterRequestQuery ;
    let requestString = '';
    let endTs = queryParam.endTs;
    if(!this.isEmptyObject(this.context) && queryParam.startTs !== '') {
      requestString = `overview/?startTs=${queryParam.startTs}&endTs=${endTs}&factory=${queryParam.factory}&line=${queryParam.lines}&shift=${queryParam.shift}`
    } else {
      requestString = `overview/`;
    }

    GetData(requestString)
      .then((response) => {
        return response.data;
      })
      .then((data) => {
        this.setState({
          mapData: data
        }, () => {
          this.GeneratePinPoints();
        });
      })
      .catch((error) => {
        console.error("error - - - - - - - - -", error);
      });

  };

  GeneratePinPoints() {

    const H = window.H;
    const platform = new H.service.Platform({
        apikey: "1YefqyWYX_I4Ze-mW_MTTh4aFmwTw35SEHaDNU6rKms"
    });

    const defaultLayers = platform.createDefaultLayers({
      lg: this.props.language
    });

    const map = new H.Map(
      this.mapRef.current,
      defaultLayers.vector.normal.map,
      {
        center: {lat: "45.173808", lng: "98.605046"},
        zoom: 0,
        pixelRatio: window.devicePixelRatio || 1
      }

    );
    this.setState(
      {
        map: map,
        defaultLayers: defaultLayers
      }
    );
    this.GeneratePoints(map, defaultLayers);

  }

  GeneratePoints(map, defaultLayers) {
    // MapEvents enables the event system
    // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
    // This variable is unused and is present for explanatory purposes
    const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));

    // Create the default UI components to allow the user to interact with them
    // This variable is unused
    const ui = H.ui.UI.createDefault(map, defaultLayers);
    this.addInfoBubble(map, ui);
    this.setState({ map });
    this.setStyle(map);

    let height = window.screen.height;
    this.setState(
      {
        maxHeight: height
      }
    );
  }

  componentDidMount() {

      this.GetFactoryOverview();

  }

  componentWillUnmount() {
    if(this.state.map) {
      this.state.map.dispose();
    }
  }

  render() {
    return <div ref={this.mapRef} className='map-region' style={{ width: "100%", height: window.screen.height - 390 }} />;
  }
}

export default withTranslation()(Map)